
export const getFullYear =()=> new Date().getFullYear();